
import BatteryCharging from "../../../assets/filled/BatteryCharging.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function BatteryChargingIcon({ className, dataTestid = "BatteryChargingIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <BatteryCharging data-testid={dataTestid} className={classes} {...rest} />
  );
}
